module.exports = __webpack_public_path__ + "img/4_66.db87b3ff.png";